// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const sendMailingListSubscribeEmail = async ({
    test,
}: {
    test: boolean,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleSendMailingListSubscribeEmail = httpsCallable<
        Record<
            string,
            boolean
        >,
        boolean
    >(
        functions,
        'sendMailingListSubscribeEmail',
    );
    return handleSendMailingListSubscribeEmail({
        test,
    }).then((result) => {
        const success = result.data as boolean;
        return success;
    }).catch((err) => {
        throw err;
    });
};

export default sendMailingListSubscribeEmail;
